<template>
  <div
    v-show="showEpComp"
    class="new-mask"
    @click="maskClick"
  >
    <div class="plot-pop">
      <div class="plot-pop-tit">
        <div class="tit reverse">
          选集
        </div>
        <div
          v-if="plotUpdatingEp > 0"
          class="plot-nums"
        >
          {{ epText }}
        </div>
      </div>
      <ul
        v-if="showNumStyle"
        class="plot-pop-con2"
      >
        <template v-for="(value, i) in numList">
          <li
            v-if="i > 0"
            :key="i"
            :class="{ dis: !value }"
          >
            <a
              :href="value ? getUrl(i) : 'javascript:void(0);'"
              :uigs="'episode_num_click_' + i"
            >
              {{ i }}
            </a>
          </li>
        </template>
      </ul>
      <ul
        v-else
        class="plot-pop-con1"
      >
        <li
          v-for="(item, key, index) in titleList"
          :key="index"
        >
          <template v-if="index + 1 <= plotUpdatingEp">
            <a
              :href="getUrl(key)"
              :uigs="'episode_title_click_' + key"
            >
              {{ item }}
            </a>
          </template>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    showEpComp: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState('summary', ['itemData']),
    dockey() {
      return this.itemData.dockey;
    },
    showNumStyle() {
      return this.itemData.plot_info.showNumStyle;
    },
    numList() {
      let array = [];
      const item = this.itemData;
      if (item) {
        const { plot_info: plotInfo } = item;
        if (Object.keys(plotInfo).length > 0) {
          const { kv_episode_range } = plotInfo;
          const { plotUpdatingEp } = this;
          array = this.fillEpisodeList(kv_episode_range, plotUpdatingEp);
        }
      }
      return array;
    },
    titleList() {
      return this.itemData.plot_info.title_list;
    },
    plotUpdatingEp() {
      const { plotUpdatingEp = [] } = this.itemData.plot_info;
      return plotUpdatingEp[plotUpdatingEp.length - 1];
    },
    epText() {
      const { plot_info: plotInfo } = this.itemData;
      if (Object.keys(plotInfo).length > 0) {
        const { finishEpisode } = plotInfo;
        const { plotUpdatingEp } = this;
        if (plotUpdatingEp === finishEpisode && finishEpisode > 0) {
          return `共${finishEpisode}集`;
        }
        return `更新至${plotUpdatingEp}集`;
      }
      return '';
    },
  },
  methods: {
    maskClick(e) {
      if (e.target.className === 'new-mask') {
        this.$emit('hideMask');
        this.$parent.stopBodyScroll(false);
      }
    },
    fillEpisodeList(array, length) {
      const newArray = new Array(length + 1).fill(0);
      for (let i = 0; i < array.length; i += 1) {
        const value = array[i];
        if (!Array.isArray(value)) return [];
        if (value.length === 1) {
          newArray.fill(1, value[0]);
        } else if (value.length === 2) {
          newArray.fill(1, value[0], value[1] + 1);
        }
      }
      return newArray;
    },
    myStringify(obj) {
      let queryStr = '';
      const queryArr = [];
      Object.keys(obj).forEach((key) => {
        queryArr.push(`${key}=${encodeURIComponent(obj[key])}`);
      });
      queryStr = queryArr.join('&');
      return queryStr;
    },
    getUrl(num) {
      const p = {
        key: this.itemData.dockey,
        ep: num,
      };
      // 白牌参数
      const { spver } = this.$route.query;
      if (spver && spver === 1) {
        p.spver = 1;
      }
      return `/summary/plot?${this.myStringify(p)}`;
    },
  },
};
</script>

<style lang="scss">
.new-mask {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 10;
}

.plot-pop {
  position: absolute;
  max-height: 100%;
  left: 0;
  width: 100%;
  bottom: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0 15px 0 15px;
  background: rgba(255, 255, 255, 1);
  border-radius: 10px 10px 0px 0px;
}

.plot-pop-tit {
  padding-top: 20px;
  padding-bottom: 8px;
  position: relative;
  display: flex;
  justify-content: space-between;
}

.plot-pop-tit .tit {
  font-size: 19px;
  color: #222;
  position: relative;
  padding-right: 13px;
  font-weight: bold;
}

.plot-pop-tit .tit.reverse i {
  -webkit-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  transform: rotate(180deg);
  -webkit-transform-origin: center center;
  -ms-transform-origin: center center;
  transform-origin: center center;
}

.plot-pop-tit .tit i {
  position: absolute;
  right: 0;
  top: 50%;
  width: 7px;
  height: 11px;
  margin-top: -5.5px;
}

.plot-pop-tit .tit i:before {
  content: '';
  position: absolute;
  right: 0;
  top: 0;
  background-position: -35px -29px;
  width: 7px;
  height: 4px;
}

.plot-pop-tit .tit i:after {
  content: '';
  position: absolute;
  right: 0;
  bottom: 0;
  background-position: -20px -29px;
  width: 7px;
  height: 4px;
}

.plot-pop-tit .plot-nums {
  font-size: 15px;
  color: #999;
}

.plot-pop-con1 {
  max-height: 402px;
  min-height: 122px;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}

.plot-pop-con1::-webkit-scrollbar {
  display: none;
}

.plot-pop-con1 li {
  height: 56px;
  line-height: 56px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-bottom: 1px solid #f2f2f2;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: normal;
  white-space: nowrap;
  display: block;
  a {
    font-size: 17px;
    color: #222;
  }
}

.plot-pop-con2 {
  display: flex;
  max-height: 342px;
  min-height: 66px;
  flex-wrap: wrap;
  justify-content: flex-start;
  padding-top: 16px;
  padding-bottom: 10px;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}
.plot-pop-con2::-webkit-scrollbar {
  display: none;
}
.plot-pop-con2 li {
  width: 18%;
  margin-right: 2.5%;
  height: 50px;
  line-height: 50px;
  text-align: center;
  background: rgba(245, 245, 245, 1);
  font-size: 15px;
  margin-bottom: 7px;
  border-radius: 3px;
  a {
    font-size: 15px;
    color: rgba(0, 0, 0, 1);
  }
}

.plot-pop-con2 li:nth-child(5n) {
  margin-right: 0;
}
.plot-pop-con2 .dis {
  color: #ccc;
}
</style>
